/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonthPlanRemoveVariableCostRequestDto
 */
export interface MonthPlanRemoveVariableCostRequestDto {
  /**
   *
   * @type {string}
   * @memberof MonthPlanRemoveVariableCostRequestDto
   */
  fundId: string;
}

export function MonthPlanRemoveVariableCostRequestDtoFromJSON(json: any): MonthPlanRemoveVariableCostRequestDto {
  return MonthPlanRemoveVariableCostRequestDtoFromJSONTyped(json, false);
}

export function MonthPlanRemoveVariableCostRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): MonthPlanRemoveVariableCostRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    fundId: json["fundId"],
  };
}

export function MonthPlanRemoveVariableCostRequestDtoToJSON(value?: MonthPlanRemoveVariableCostRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    fundId: value.fundId,
  };
}
